const container = document.getElementById('root');
const dataset = container?.dataset;
const { turnstileSiteKey } = dataset ?? {};

/**
 * Clé publique du widget Turnstile. En local, la clé de test de Cloudflare, qui délivre un jeton
 * sans rien demander et que la clé secrète de test du backend accepte.
 *
 * Absente, le formulaire d'inscription s'affiche sans captcha : c'est ce que fait aussi le backend
 * quand il n'a pas de clé secrète.
 */
const TURNSTILE_SITE_KEY =
    process.env.NODE_ENV === 'development' ? '1x00000000000000000000AA' : turnstileSiteKey || undefined;

export default TURNSTILE_SITE_KEY;
